import React, { Component } from 'react';
import { Page, Text, Document, StyleSheet, View, Image } from '@react-pdf/renderer';
import get from 'lodash/get';
const PRIMARY_ORANGE = '#f06024';
const PRIMARY_BLUE = '#153b62';
class PdfPlainInputs extends Component {
  constructor() {
    super();

    this.state = {
      hideFile: true,
      viewFile: 'View Current File',
      uploadPrompt: 'Upload New File',
    };
  }

  render() {
    let inputField;

    const { nature, response, title } = this.props;

    // Monkey patch to avoid nested objects making it through.
    let getKeys = typeof response === 'object' && Object.keys(response || {});

    let finalResponse = getKeys ? get(response || {}, getKeys[0]) : response;

    switch (nature) {
      case 'file':
        inputField = response.length ? (
          <View className="input-file-upload">
            <Text
              style={{ fontSize: 13 }}
              href={response}
              className={`file-link ${this.state.hideFile ? '' : 'hidden'}`}
              target="_blank"
              rel="noopener noreferrer">
              {this.state.viewFile}
            </Text>
          </View>
        ) : null;
        break;
      case 'radio':
        inputField = (
          <View style={styles.container} tabIndex="1">
            <Text style={styles.answer}>{finalResponse}</Text>
          </View>
        );
        break;
      case 'checkbox':
        inputField = (
          <View style={styles.container}>
            <Text style={styles.answer}>{finalResponse}</Text>
          </View>
        );
        break;
      case 'textarea':
        inputField = (
          <View className="input-field">
            <Text style={styles.answer}>{finalResponse}</Text>
          </View>
        );
        break;
      default:
        inputField = (
          <View className="input-field">
            {title ? <Text style={styles.text}>{title}</Text> : null}
            <Text style={styles.answer}>{finalResponse}</Text>
          </View>
        );
        break;
    }

    return inputField;
  }
}

export default PdfPlainInputs;

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  text: {
    margin: 12,
    fontSize: 14,
    textAlign: 'justify',
    fontFamily: 'Times-Roman',
    color: '#000',
  },
  question: {
    color: PRIMARY_BLUE,
    fontSize: 15,
    textAlign: 'justify',
    fontFamily: 'Times-Roman',
    paddingBottom: '1rem',
  },
  questionTitle: {
    color: PRIMARY_BLUE,
    borderBottomColor: PRIMARY_ORANGE,
    borderBottomWidht: 1,
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  header: {
    fontSize: 14,
    marginBottom: 20,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  answer: {
    color: PRIMARY_ORANGE,
    fontSize: 12,
  },
});



// WEBPACK FOOTER //
// ./src/components/CDRSections/Responses/ResponsesDownload/PdfPlainInputs.js